import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import axios from "../../axiosConfig";

const cardSx = {
  background: "#fff",
  borderRadius: "16px",
  boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
  padding: "32px 28px",
  maxWidth: 420,
  textAlign: "center",
};

export default function SmsUnsubscribe() {
  const { code } = useParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        await axios.get(`/api/sms/unsubscribe/${encodeURIComponent(code)}`);
        if (!cancelled) {
          setState("success");
        }
      } catch (err) {
        if (cancelled) {
          return;
        }
        setState(err.response?.status === 400 ? "invalid" : "error");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [code]);

  let title = "Processing…";
  let message = "Please wait while we update your preferences.";

  if (state === "success") {
    title = "You're unsubscribed";
    message = "You will no longer receive SMS from this sender.";
  } else if (state === "invalid") {
    title = "Invalid unsubscribe link";
    message = "This link is not valid.";
  } else if (state === "error") {
    title = "Something went wrong";
    message = "Please try again later.";
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f3f5f8",
        px: 2,
      }}
    >
      <Box sx={cardSx}>
        {state === "loading" ? (
          <CircularProgress size={32} sx={{ mb: 2 }} />
        ) : null}
        <Typography variant="h5" component="h1" sx={{ fontSize: 20, mb: 1.5 }}>
          {title}
        </Typography>
        <Typography sx={{ color: "#555", lineHeight: 1.5 }}>{message}</Typography>
      </Box>
    </Box>
  );
}
